import type { ReactNode } from 'react';

import logo from '@/assets/logo.jpg';

interface PublicShellProps {
  brand: string;
  badge?: string;
  maxWidth?: 'md' | 'lg' | 'xl' | '2xl';
  children: ReactNode;
}

const WIDTHS: Record<NonNullable<PublicShellProps['maxWidth']>, string> = {
  md: 'max-w-2xl',
  lg: 'max-w-3xl',
  xl: 'max-w-4xl',
  '2xl': 'max-w-5xl',
};

// Shared layout for the public, no-auth onboarding pages (Review / T&C / Pay).
export function PublicShell({ brand, badge, maxWidth = 'lg', children }: PublicShellProps) {
  return (
    <div className="min-h-screen bg-secondary/40 text-foreground">
      <header className="border-b border-border bg-card">
        <div className={`mx-auto flex ${WIDTHS[maxWidth]} items-center justify-between px-4 py-3`}>
          <div className="flex items-center gap-2">
            <img src={logo} alt="AdvisorKhoj logo" className="h-8 w-8 rounded-lg object-contain" />
            <div className="text-sm font-extrabold">{brand}</div>
          </div>
          {badge && (
            <span className="rounded-full border border-border bg-secondary px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
              {badge}
            </span>
          )}
        </div>
      </header>
      <main className={`mx-auto ${WIDTHS[maxWidth]} px-4 py-8`}>{children}</main>
    </div>
  );
}

export interface PublicSnapshot {
  leadCode?: number;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  arn?: string;
  email?: string;
  products?: { name: string; price: number }[];
  languages?: string[];
}
